module.exports = __webpack_public_path__ + "static/media/calendar.57d546f3.svg";